<template>
  <oceano-default-section :section="section" :menu="menu"
                          class="menu--section-oceano_drinks"></oceano-default-section>
</template>

<script lang="ts">
/**
 * Custom component for Oceano drink menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-10-05 (1.0.0) (jhoward)
 *      - <OceanoDrinkSection> adds a drink layout for Oceano menu sections.
 *
 *  2025-04-08 (1.0.1) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <OceanoDrinkSection>.
 *    - Remove "visual_" prefix from class names in <OceanoDrinkSection>.
 */

import {defineComponent, PropType} from "vue";
import OceanoDefaultSection from "./OceanoDefaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'OceanoDrinkSection',
  components: {OceanoDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
</script>

<style scoped>
.menu--section-oceano_drinks:deep(.menu--item_subgroup) {
  grid-gap: 0.2em;
}

.menu--section-oceano_drinks:deep(.menu--item .menu--item_title) {
  font-weight: normal;
}

.menu--section-oceano_drinks:deep(.menu--item .menu--item_price) {
  font-weight: normal;
}
</style>